export default class Zoom {

    canvas = null
    scale = 1;
    scalar = 1.1;

    lastZoom = {
        width: null,
        height: null,
        zoom: null
    }

    constructor(canvas) {
      this.canvas = canvas

      this.resetZoom()

      // Time out is necessary for correct elements size reading
      window.addEventListener('resize', () => setTimeout(() => this.resetZoom(), 200))
    }

    zoomIn() {
      this.scale = this.scale * this.scalar
    
      this.setZoom(
        this.canvas.getWidth() * this.scalar,
        this.canvas.getHeight() * this.scalar,
        this.canvas.getZoom() * this.scalar
      )
    }
      
    zoomOut() {
      this.scale = this.scale / this.scalar
    
      this.setZoom(
        this.canvas.getWidth() / this.scalar,
        this.canvas.getHeight() / this.scalar,
        this.canvas.getZoom() / this.scalar
      )
    }

    setZoom(width, height, zoom = 1, save = true) {
      this.scale = zoom

      this.canvas.setHeight(height)
      this.canvas.setWidth(width)
      this.canvas.setZoom(zoom)
    
      if (save) {
        this.lastZoom.height = height
        this.lastZoom.width = width
        this.lastZoom.zoom = zoom
      }
    
      this.canvas.renderAll()
    }

    resetZoom(save = false) {
      const container = this.canvas.getElement().closest('.box-card.canvas .el-card__body');
      const widthScale = container.clientWidth / this.canvas.width;
      const heightScale = (container.clientHeight) / this.canvas.height;

      const scale = Math.min(widthScale, heightScale)

      this.setZoom(this.canvas.getWidth() * scale, this.canvas.getHeight() * scale, this.canvas.getZoom() * scale, save);
    }

    restoreZoom() {
        if (this.lastZoom.width) {
          this.setZoom(
            this.lastZoom.width,
            this.lastZoom.height,
            this.lastZoom.zoom
          )
        }
    }
}